import type {SVGProps} from 'react';

export function Fa7Solid3(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M240 352c-17.7 0-32-14.3-32-32s14.3-32 32-32h112c35.3 0 64-28.7 64-64s-28.7-64-64-64H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c70.7 0 128 57.3 128 128c0 38.2-16.8 72.5-43.3 96c26.6 23.5 43.3 57.8 43.3 96c0 70.7-57.3 128-128 128H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h160c35.3 0 64-28.7 64-64s-28.7-64-64-64z"></path>
    </svg>);
}